module.exports = __webpack_public_path__ + "static/media/SUCESIONES.45d8390f.pdf";